<template>
  <d-container fluid class="main-content-container px-4">
    <d-row>
      <!-- Users by Device (lite) -->

      <d-col lg="4" md="6" sm="12" class="mb-4">
        <d-card class="card-small">
          <d-card-header class="border-bottom">
            <h6 class="m-0">Stats</h6>
            <div class="block-handle"></div>
          </d-card-header>
          <d-card-body class="p-0">
            <d-list-group flush class="list-group-small">
              <d-list-group-item class="d-flex px-3 bg-transparent">
                <span class="text-semibold text-fiord-blue"
                  >Today's Orders</span
                >
                <span
                  class="ml-auto text-right text-primary text-stat text-monospace"
                >
                  {{ today.count }}
                </span>
              </d-list-group-item>
              <d-list-group-item class="d-flex px-3 bg-transparent">
                <span class="text-semibold text-fiord-blue">Today's Sales</span>
                <span
                  class="ml-auto text-right text-primary text-stat text-monospace"
                >
                  {{ today.sales }}
                </span>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
          <d-card-footer class="bg-primary p-0">
          </d-card-footer>
        </d-card>
      </d-col>
            <d-col lg="4" md="6" sm="12" class="mb-4">
        <printers />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Printers from "@/components/common/Printers.vue";
import formatters from "@/components/DataGrid/formatters";

export default {
  components: {
    Printers
  },
  data() {
    return {
      dateRange: {
        from: null,
        to: null
      },
      columnDefs: null,
      rowData: null
    };
  },
  created() {
    this.$store.dispatch("app/setTitles", { title: "", subtitle: "" });
    this.$store.dispatch("shop/getTodayStats");
  },
  beforeMount() {
    this.columnDefs = [
      { headerName: "Make", field: "make", sortable: true, filter: true },
      { headerName: "Model", field: "model", sortable: true, filter: true },
      { headerName: "Price", field: "price", sortable: true, filter: true }
    ];

    this.rowData = [
      { make: "Toyota", model: "Celica", price: 35000 },
      { make: "Ford", model: "Mondeo", price: 32000 },
      { make: "Porsche", model: "Boxter", price: 72000 }
    ];
  },
  methods: {
    handleApprove(id) {
      alert(`Approving discussion id: ${id}`); // eslint-disable-line no-alert
    },
    handleReject(id) {
      alert(`Rejecting discussion id: ${id}`); // eslint-disable-line no-alert
    },
    handleEdit(id) {
      alert(`Editing discussion id: ${id}`); // eslint-disable-line no-alert
    },
    handleViewAllComments() {
      alert("Viewing all comments!"); // eslint-disable-line no-alert
    }
  },

  computed: {
    today() {
      return {
        count: this.$store.state.shop.today.order_count,
        sales: formatters.currency.usd(this.$store.state.shop.today.gross_sales)
      }
    },
    profile() {
      return this.$store.state.profile.profile;
    }
  }
};
</script>

<style>
.card-small {
  border-radius: 1rem;
}

.text-stat {
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.1;
}
</style>
